import React, { Component, Suspense } from 'react';
import Footer from './Footer';
import axios from 'axios';
import { backgroundImage, api, contactUs_api, get_json } from './common';
import { connect } from 'react-redux'
import Loader from './Loader'
import { useImage } from 'react-image'
import  {imagePath} from './common'
function BgComponent(props) {
	const { src } = useImage({
		srcList: require('./images/newsletter.jpg')
	})
	return (
		<div className="headerImage" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', height: 250, position: 'relative' }}>
			<div className="center_text">
				<h3 className="wthree_text_info">{props.contact_title}</h3>
				<p className="contact_content">{props.contact_content}</p>
			</div>
		</div>
	)
}

class Contact extends Component {

	constructor(props) {
		super(props);
		this.state = { data: [], name: '', email: '', message: '', phone: '', "errorName": "", success: false };

	}

	async componentDidMount() {
		window.scrollTo(0, 0)
		if (this.props.alldata === null) {
			await get_json(this)
			this.props.setresponseJson(this.state.data)
		} else {
			await this.setState({ data: this.props.alldata })
		}
		let Socialicons = [];
		if (typeof this.state.data.social_json !== 'undefined') {
			let social = JSON.parse(this.state.data.social_json);
			if (Object.keys(social).length > 0) {
				social.forEach((item, i) => {
					if (item.type === 'facebook') {
						var icon = 'fa fa-facebook';
						var class_name = 'facebook';
					} else if (item.type === 'twitter') {
						icon = 'fa fa-twitter';
						class_name = 'twitter';
					} else if (item.type === 'instagram') {
						icon = 'fa fa-instagram';
						class_name = 'instagram';
					} else if (item.type === 'linkedin') {
						icon = 'fa fa-linkedin';
						class_name = 'linkedin';
					}
					Socialicons.push(
						<li key={i}><a href={item.url} className={`${class_name}`} target="_blank" rel='noreferrer noopener'>
							<div className="front"><i className={`${icon}`} aria-hidden="true"></i></div>
						</a></li>
					);
				});
				this.setState({ Socialicons: Socialicons });
				localStorage.setItem('Socialicons', JSON.stringify(this.state.Socialicons));
			}
		}
	}

	handleSubmit = async (event) => {
		event.preventDefault();
		var name = await this.state.name;
		var email = await this.state.email;
		var phone = await this.state.phone;
		var message = await this.state.message;
		var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		this.setState({ successMSg: '' })
		if (name === '' || name === null) {
			this.setState({ "errorMsg": "Please Enter Name", "errorName": "name" });

		} else if (!email.match(mailformat)) {
			this.setState({ "errorMsg": "Please Enter Valid Email", "errorName": "email" });
		} else if (message === '' || message === null) {
			this.setState({ "errorMsg": "Please Enter Message", "errorName": "message", });
		}
		else if (name !== '' && email !== '' && message !== '') {
			var data = await new FormData();
			await data.append('user_name', name);
			await data.append('user_email', email);
			await data.append('user_phone', phone);
			await data.append('user_message', message);
			await data.append('admin_email', this.state.data.email);
			await data.append('user_id', this.state.data.user_id);

			const requestOptions = {
				method: 'POST',
				mode: 'no-cors',
				headers: {
					'Content-Type': 'application/json',
					"Access-Control-Allow-Origin": "*",
				},
				body: data,
			};

			fetch("https://demo.softpulseinfotech.com/reactjs-website/admin_cms/react_mail.php", requestOptions)
				.then((response) => response.json()).then(async (responseJson) => {
					console.log(responseJson, "responseJson")
					this.setState({ "name": '', "email": '', "message": '', "phone": "" });
					this.setState({ "successMSg": "Your information has been send successfully", success: true, "errorMessage": false, "errorEmail": false, "errorName": false, "errorEmails": false });
				}).catch((error) => {
					console.log(error, "error")
				});
		}

	}

	render() {
		return (
			<div className="main_contact">
				{/* {
				<Suspense fallback={<div className="headerImage" style={{ height: 250, position: 'relative' }}>
					<div class="place_effect showed">
						<div class="img_div"></div>
					</div>
				</div>}>
					<BgComponent contact_title={this.state.data.contact_title} contact_content={this.state.data.contact_content}></BgComponent>
				</Suspense>} */}
				<div className="contact-main w-left">

					<div className="container">
						<div class="center_text">
							<h3>{this.state.data.contact_title}</h3>
							<p class="contact_content">{this.state.data.contact_content}</p>
						</div>
						<div className="row">
							<div className="col-md-6 con-form">
								<div className="contact-form">
									<h4 className="white-w3ls">Contact <span>Form</span></h4>
									<form onSubmit={(e) => this.handleSubmit(e)}>
										<div className="styled-input agile-styled-input-top">
											<input type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value, errorName: '' })} />
											{this.state.errorName === "name" &&
												<h6>{this.state.errorMsg}</h6>
											}
											<label>Name*</label>
										</div>
										<div className="styled-input">
											<input type="text" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value, errorName: '' })} />
											{this.state.errorName === "email" &&
												<h6>{this.state.errorMsg}</h6>
											}

											<label>Email*</label>
										</div>
										<div className="styled-input">
											<input type="text" value={this.state.phone} onChange={(e) => this.setState({ phone: e.target.value })} />
											<label>Phone</label>
										</div>
										<div className="styled-input">
											<textarea value={this.state.message} onChange={(e) => this.setState({ message: e.target.value, errorName: '' })}></textarea>
											{this.state.errorName === "message" &&
												<h6>{this.state.errorMsg}</h6>
											}
											<label>Message*</label>
										</div>
										<div className="successMsg">
											{this.state.success &&
												<h6>{this.state.successMSg}</h6>
											}
										</div>
										<input type="submit" value="SEND" />
									</form>
								</div>
							</div>
							<div className="col-md-6 f-left address-grid">
								<h4>For More <span>Information</span></h4>

								<div className="mail-agileits-w3layouts">
									<i className="fa fa-volume-control-phone" aria-hidden="true"></i>
									<div className="contact-right">
										<p>Telephone </p><span>{this.state.data.phone}</span>
									</div>
								</div>

								<div className="mail-agileits-w3layouts">
									<i className="fa fa-envelope-o" aria-hidden="true"></i>
									<div className="contact-right">
										<p>Mail </p><a href="mailto:info@example.com">{this.state.data.email}</a>
									</div>
								</div>

								<div className="mail-agileits-w3layouts">
									<i className="fa fa-map-marker" aria-hidden="true"></i>
									<div className="contact-right">
										<p>Location</p><span>{this.state.data.location}</span>
									</div>
								</div>

								<ul className="social-nav model-3d-0 footer-social w3_agile_social">
									<li className="share">Follow us on : </li>
									{this.state.Socialicons}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
}
const mapStateToProps = (state) => {

	return {
		alldata: state.responseJson,

	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Contact);

// export default Contact;
